import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Poppins:wght@400;500;600;700&display=swap');
  
  :root {
    --background: #f8f9fc;
    --foreground: #1e293b;
    --card: #ffffff;
    --card-foreground: #1e293b;
    --border: #e2e8f0;
    --input: #e2e8f0;
    --primary: #03a9f4;
    --primary-foreground: #ffffff;
    --secondary: #9a72e9;
    --secondary-foreground: #ffffff;
    --accent: #9a72e9;
    --accent-foreground: #ffffff;
    --muted: #f1f5f9;
    --muted-foreground: #64748b;
    --radius: 0.5rem;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background-color: var(--background);
    color: var(--foreground);
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  * {
    box-sizing: border-box;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-weight: 600;
    margin-top: 0;
    color: var(--foreground);
  }

  p {
    line-height: 1.6rem;
    color: var(--foreground);
  }

  a {
    color: var(--primary);
    text-decoration: none;
    transition: color 0.2s ease;
    
    &:hover {
      color: #0288d1;
    }
  }

  button {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  /* Custom scrollbar */
  /* ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: var(--muted);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  } */
`;
